<template>
  <v-container class="container-pedido">
    <v-row class="header-fixo elevation-2" >
      <v-btn
      class="buton-add"
        color="primary"
        @click="adicionarPedido"
      >
        <v-icon left>mdi-plus</v-icon>
        Adicionar
      </v-btn>

      <v-col cols="12" class="d-flex justify-center pb-2">

        <v-btn
          small
          tile
          class="mx-1 rounded"
          :color="filtroTipo === 'pedido' ? 'primary' : 'white'"
          :class="filtroTipo === 'pedido' ? 'white--text' : 'grey--text text--darken-2'"
          @click="filtroTipo = 'pedido'"
        >
          Pedidos
        </v-btn>

        <v-btn
          small
          tile
          class="mx-1 rounded"
          :color="filtroTipo === 'orcamento' ? 'amber darken-2' : 'white'"
          :class="filtroTipo === 'orcamento' ? 'white--text' : 'grey--text text--darken-2'"
          @click="filtroTipo = 'orcamento'"
        >
          Orçamentos
        </v-btn>

        <v-btn
          small
          tile
          class="mx-1 rounded"

          :color="filtroTipo === 'todos' ? 'grey darken-3' : 'white'"
          :class="filtroTipo === 'todos' ? 'white--text' : 'grey--text text--darken-2'"
          @click="filtroTipo = 'todos'"
        >
          Todos
        </v-btn>

      </v-col>
    </v-row>

    <v-row class="lista-com-padding">

      <v-col
        v-for="pedido in listaFiltrada"
        :key="pedido.numero"
        cols="12"
        class="mb-3">
        <v-card class="mx-4 card">
          <div 
            class="card__consumidor" 
            :style="pedido.orcamento === 1 ? 'background-color: #ffa92d; cursor: pointer;' : 'cursor: pointer;'"
            @click="pedido.showItems = !pedido.showItems"
            v-ripple
          >
            <div class="d-flex justify-space-between align-center">
              
              <div class="d-flex flex-column flex-grow-1 mr-3">
                <b>
                  {{ pedido.clienteCodigo }} - 
                  <span v-if="pedido.clinome">{{ pedido.clinome }}</span>
                  <span v-else>CONSUMIDOR DIVERSOS</span>
                </b>
                
                <div class="d-flex justify-space-between align-end mt-1 w-100" style="font-size: 0.85rem; opacity: 0.95;">
  
                  <div class="d-flex flex-column">
                    <span v-if="pedido.data" class="d-flex align-center mb-1">
                      Pedido: {{ FormataDataGeral(pedido.data) }}
                    </span>

                    <span v-if="pedido.datatransmissao" class="d-flex align-center">
                      Transmitido: {{ FormataDataGeral(pedido.datatransmissao) }}
                    </span>
                  </div>
                  
                  <span v-if="pedido.total !== null && pedido.total !== undefined" class="d-flex align-center ml-3">
                    <v-icon size="14" color="white" class="mr-1">mdi-cash</v-icon>
                    <b style="font-size: 0.95rem;">{{ formatarValor(pedido.total) }}</b>
                  </span>
                </div>
              </div>

              <div class="d-flex align-center">
                <v-icon 
                  v-if="pedido.atendido == 1" 
                  :color="'green accent-4'" 
                  size="18"
                  title="Enviado"
                  class="mr-3"
                >
                  mdi-circle
                </v-icon>
                <v-icon color="white">
                  {{ pedido.showItems ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </div>
            </div>
          </div>

          <v-expand-transition>
            <div v-if="pedido.showItems">
              
              <div class="card__detalhe py-3">
                <div class="card__detalhe__icone-wrapper">
                  <v-icon class="card__detalhe__icone" size="60">
                    mdi-account-details
                  </v-icon>
                </div>
                
                <span class="card__detalhe-conteudo">
                  <template v-if="pedido.numeroExibicao">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">
                        {{ pedido.orcamento === 1 ? 'Nº Orçamento:' : 'Nº Pedido:' }}
                      </span>
                      <b class="">{{ pedido.numeroExibicao }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>

                  <template v-if="pedido.observacao">
                    <div class="d-flex justify-space-between my-1">
                      <span class="font-weight-medium">Observação: </span>
                      <b class="">{{ pedido.observacao }}</b>
                    </div>
                    <v-divider></v-divider>
                  </template>

                  <template v-if="pedido.idtipopedidovenda">
                    <div class="d-flex justify-space-between my-1 mb-0">
                      <span class="font-weight-medium">Tipo: </span>
                      <b class="">{{ pedido.idtipopedidovenda }} - {{ pedido.descricaoTipo }}</b>
                    </div>
                  </template>
                </span>
              </div>

              <div class="lighten-4 px-4 pb-3 pt-1" style="background-color: #f9f9f9;">
                <v-divider class="mb-2"></v-divider>
                <div class="text-subtitle-2 mb-2">Itens do Pedido:</div>
                
                <simplebar 
                  v-if="pedido.itens && pedido.itens.length > 0" 
                  class="table-scroll-container" 
                  data-simplebar-auto-hide="false"
                >
                  <div 
                    v-for="(item, index) in pedido.itens.filter(i => !i.DT_Cancelado)" 
                    :key="index"
                    class="mb-2 pb-2"
                    style="border-bottom: 1px dashed #e9e9e9;"
                  >
                    <div class="text-body-2 font-weight-medium mb-1 text-truncate">
                      {{ item.idcortamanhofinal + ' - ' + item.descricao }}
                    </div>

                    <div class="d-flex justify-space-between align-center">
                      <span class="caption grey--text text--darken-2">
                        {{ item.quantidade }} x {{ formatarValor(item.valorliquido) }}
                      </span>
                      <span class="font-weight-bold body-2 green--text text--darken-3">
                        {{ formatarValor(item.quantidade * item.valorliquido) }}
                      </span>
                    </div>
                  </div>
                </simplebar>

                <div v-if="!pedido.itens || pedido.itens.length === 0" class="text-center caption pa-2">
                  Nenhum item no pedido.
                </div>

                <div class="d-flex justify-end mt-3 pt-2" style="border-top: 1px solid #e0e0e0;">
                  
                  <v-btn 
                    :color="pedido.orcamento === 1 ? '#ffa92d' : 'primary'" 
                    :class="pedido.orcamento === 1 ? 'white--text mr-2' : 'mr-2'"
                    small 
                    @click.stop="abrirDetalhesPedido(pedido)"
                  >
                    <v-icon left size="18">mdi-pencil</v-icon>
                    Editar
                  </v-btn>

                  <v-btn 
                    :color="pedido.orcamento === 1 ? '#ffa92d' : 'primary'" 
                    small 
                    outlined
                    @click.stop="gerarPdf(pedido)"
                  >
                    <v-icon left size="18">mdi-printer</v-icon>
                    PDF
                  </v-btn>

                </div>
              </div>

            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>  

    
    <v-dialog v-model="dialogVendedorNaoLogado" max-width="400">
      <v-card>
        <v-card-title color="white" class="headline primary white--text text--darken-2">
          Erro
        </v-card-title>
        
        <v-card-text class="pt-4 body-1 black--text">
          Não é possível fazer um novo pedido. <strong>Nenhum vendedor logado foi identificado.</strong>
          <br><br>
          Por favor, faça o login novamente para continuar.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="dialogVendedorNaoLogado = false">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import db from '@/plugins/dexie';

import moment from 'moment';
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

export default {
  name: 'ViewPedido',

  components: {
    simplebar
  },

  data() {
    return {
      pedidos: [],
      loading: false,
      filtroTipo: 'pedido',
      dialogVendedorNaoLogado: false,
    };
  },

  mounted() {
    if (Object.keys(this.$route.query).length === 0) {
      this.carregarPedidos();
    }
  },

  computed: {
    listaFiltrada() {
      if (this.filtroTipo === 'todos') {
        return this.pedidos;
      }
      
      if (this.filtroTipo === 'orcamento') {
        return this.pedidos.filter(p => p.orcamento === 1);
      }
      
      if (this.filtroTipo === 'pedido') {
        return this.pedidos.filter(p => p.orcamento !== 1);
      }
      
      return this.pedidos;
    }
  },

  created() {
    sessionStorage.removeItem('filtro_historico_produto');
    sessionStorage.removeItem('produto_selecionado_retorno');
    sessionStorage.removeItem('itensVisuaisLaranja');
    sessionStorage.removeItem('pedidoAtualItens');
    sessionStorage.removeItem('retornoIdPedido');
    sessionStorage.removeItem('retornoIdCliente');
    sessionStorage.removeItem('vendasView_clienteAtual');
  },

  methods: {
    abrirDetalhesPedido(pedido) {
      this.$router.push({
        path: '/cadastro-pedido',
        query: { 
          idpedido: pedido.idpedido,
          idpedidoditemd: pedido.idpedidoditemd,
        }
      });
      // console.log('teste', pedido.idpedidoditemd, 'id', pedido.id )
    },

    async adicionarPedido() {
      let idVendedor = null;
      try {
        const paramsDb = await db.parametro.toArray();
        if (paramsDb.length > 0) {
          idVendedor = paramsDb[0].idvendedorlogado; 
        }
      } catch (e) {
        console.error("Erro ao recuperar vendedor logado:", e);
      }

      if (!idVendedor) {
        this.dialogVendedorNaoLogado = true;
        return;
      }

      sessionStorage.removeItem('filtro_historico_produto');
      sessionStorage.removeItem('produto_selecionado_retorno');
      sessionStorage.removeItem('itensVisuaisLaranja');
      sessionStorage.removeItem('pedidoAtualItens');
      sessionStorage.removeItem('retornoIdPedido');
      sessionStorage.removeItem('retornoIdCliente');
      sessionStorage.removeItem('vendasView_clienteAtual');
      
      const ehOrcamento = this.filtroTipo === 'orcamento';

      this.$router.push({
        path: '/cadastro-pedido',
        query: { 
          isOrcamento: ehOrcamento 
        }
      });
      // console.log(idVendedor)
    },

    gerarPdf(pedido) {
      this.$router.push({
        path: '/impressao_pedido',
        query: { id: pedido.idpedido }
      });
    },

    FormataDataGeral(date) {
      return moment.utc(date).format('DD/MM/YYYY HH:mm'); 
    },

    formatarValor(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },

    async carregarPedidos() {
      this.loading = true;
      
      let idVendedorLogado = null;
      try {
        const paramsDb = await db.parametro.toArray();
        if (paramsDb.length > 0) {
          idVendedorLogado = paramsDb[0].idvendedorlogado; 
        }
      } catch (e) {
        console.error("Erro ao recuperar vendedor logado para o filtro:", e);
      }

      const codigopessoa = this.$route.query.codigopessoa;
      const nomecliente = this.$route.query.nomecliente;
      const idtipopedidovenda = this.$route.query.idtipopedidovenda;

      const createdFrom = this.$route.query['created-from'];
      const createdBefore = this.$route.query['created-before'];

      let collection = db.pedido;
      let pedidosFiltrados = [];

      try {
        if (codigopessoa) {
          const codInt = parseInt(codigopessoa, 10);
          pedidosFiltrados = await collection
            .where('idcliente')
            .equals(codInt)
            .and(p => !p.datalimpeza)
            .toArray();
            
          pedidosFiltrados.reverse();
        } else if (nomecliente) {
          const clientes = await db.cliente
            .filter(c => c.nome.toLowerCase().includes(nomecliente.toLowerCase()))
            .toArray();
          const clienteIDs = clientes.map(c => c.idcliente);
          
          pedidosFiltrados = await collection
            .where('idcliente')
            .anyOf(clienteIDs)
            .and(p => !p.datalimpeza)
            .toArray();
            
          pedidosFiltrados.reverse();
        } else {
          pedidosFiltrados = await collection
            .orderBy('idpedido')
            .reverse()
            .and(p => !p.datalimpeza)
            .limit(200)
            .toArray();
        }

        pedidosFiltrados = pedidosFiltrados.filter(p => {
          let valido = true;

          if (idVendedorLogado && String(p.idvendedor) !== String(idVendedorLogado)) {
            valido = false;
          }

          const dataPedidoFormatada = p.data ? moment(p.data).format('YYYY-MM-DD') : '';

          if (createdFrom) {
            if (dataPedidoFormatada < createdFrom) valido = false;
          }
          
          if (createdBefore && valido) {
            if (dataPedidoFormatada > createdBefore) valido = false;
          }

          if (idtipopedidovenda && valido) {
            if (String(p.idtipopedidovenda) !== String(idtipopedidovenda)) valido = false;
          }

          return valido;
        });

        const pedidosCompletos = await Promise.all(
          pedidosFiltrados.map(async (pedido) => {
            const cliente = await db.cliente.where('idcliente').equals(pedido.idcliente).first();
            let nomeTipoPedido = pedido.idtipopedidovenda;
            if (pedido.idtipopedidovenda) {
              let tipoObj = await db.tipopedidovenda
                .where('idtipopedidovenda')
                .equals(pedido.idtipopedidovenda)
                .first();

              if (!tipoObj) {
                const idNumero = parseInt(pedido.idtipopedidovenda);
                if (!isNaN(idNumero)) {
                  tipoObj = await db.tipopedidovenda
                    .where('idtipopedidovenda')
                    .equals(idNumero)
                    .first();
                }
              }

              if (!tipoObj) {
                tipoObj = await db.tipopedidovenda
                    .where('idtipopedidovenda')
                    .equals(String(pedido.idtipopedidovenda))
                    .first();
              }
                
              if (tipoObj && tipoObj.descricao) {
                nomeTipoPedido = tipoObj.descricao;
              }
            }
            let itens = await db.pedidoitem.where('idpedido').equals(pedido.idpedido).toArray();
            if (itens.length === 0) {
              itens = await db.pedidoitem.where('idpedido').equals(String(pedido.idpedido)).toArray();
              if (itens.length === 0) {
                itens = await db.pedidoitem.where('idpedido').equals(Number(pedido.idpedido)).toArray();
              }
            }
            
            const itensComDescricao = await Promise.all(itens.map(async (item) => {
            let descricaoProduto = item.descricao && item.descricao.trim() ? item.descricao : null;
            
            if (item.idcortamanhofinal && db.produto) {
              const idLimpo = String(item.idcortamanhofinal).trim();
              
              if (!descricaoProduto) {
                let prod = null;
                const idNum = !isNaN(idLimpo) ? parseInt(idLimpo, 10) : null;

                if (idNum !== null) {
                  prod = await db.produto.where('idcortamanhofinal').equals(idNum).first();
                }
                if (!prod) {
                  prod = await db.produto.where('idcortamanhofinal').equals(idLimpo).first();
                }

                if (!prod && idNum !== null) {
                  prod = await db.produto.get(idNum);
                }
                if (!prod) {
                  prod = await db.produto.get(idLimpo);
                }

                if (prod && prod.descricao && prod.descricao.trim()) {
                  descricaoProduto = prod.descricao;
                } else {
                  descricaoProduto = `Cód. ${idLimpo}`;
                }
              }
            } else if (!descricaoProduto) {
              descricaoProduto = 'Produto sem nome';
            }

            const qtd = item.quantidade || 0;
            const vlrUnitario = item.valorunitario || 0;
            const vlrDesconto = item.valordesconto || 0; 
            const vlrLiquido = vlrUnitario - vlrDesconto;

            return {
              ...item,
              descricao: descricaoProduto,
              quantidade: qtd,
              valorunitario: vlrUnitario,
              valordesconto: vlrDesconto,
              valorliquido: vlrLiquido,
              subtotal: qtd * vlrLiquido
            };
          }));

            return {
              ...pedido,
              numeroExibicao: pedido.idpedidoback || pedido.idpedido, 
              clinome: cliente ? cliente.nome : 'CLIENTE NÃO ENCONTRADO',
              clienteCodigo: pedido.idcliente,
              observacao: pedido.observacao,
              descricaoTipo: nomeTipoPedido,
              data: pedido.data,
              total: pedido.total,
              itens: itensComDescricao,
              showItems: false
            };
          })
        );

        this.pedidos = pedidosCompletos;

      } catch (error) {
        console.error("Erro ao carregar pedidos:", error);
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    '$route.query': {
      immediate: true, 
      deep: true,
      handler() {
        this.carregarPedidos();
      },
    },
  },
};
</script>

<style scoped>
.container-pedido{
  padding: 0;
  margin: 0;
}

.header-fixo {
  justify-content: center;
  position: fixed;
  width: 100%;
  margin: -12px 0 0 0;
  z-index: 3;
  background-color: #eeeeee; 
  padding: 12px 0 12px 0;
}

.lista-com-padding {
  padding-top: 90px;
}

.card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card__consumidor {
  padding: 12px 16px;
  font-size: 1.1rem;
  color: white;
  background-color: #4c6faf;
}

.card__detalhe {
  display: flex;
  align-items: center;
  padding: 0 16px 0 16px;
  flex-grow: 1;
}

.card__detalhe__icone-wrapper {
  margin-right: 16px;
}

.card__detalhe-conteudo {
  flex-grow: 1;
  font-size: 0.9rem;
}

.card__detalhe-conteudo > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.table-scroll-container {
  max-height: 255px; 
  padding-right: 10px;
}
.table-scroll-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

@media (min-width: 960px) {
  .header-fixo {
  justify-content: center;
  position: fixed;
  width: 80%;
  margin: 0;
  z-index: 3;
  background-color: #eeeeee; 

}
.lista-com-padding {
  justify-content: center;
  margin: auto;
  width: 80%;
  padding-top: 90px;

}
.buton-add{
  padding-right: 16px;

}
}
</style>